<script setup lang="ts">
// Per-entry host: provides the dialog's close context and hosts the focus
// trap. Rendered once per stack entry by DialogRoot.

import { provide, ref, toRef } from 'vue'

import { DIALOG_CONTEXT_KEY, closeDialog, type DialogEntry } from '../dialogs'
import { useFocusTrap } from '../focus'

const props = defineProps<{
  entry: DialogEntry
  isTop: boolean
}>()

const rootRef = ref<HTMLElement | null>(null)
const isTopRef = toRef(props, 'isTop')

useFocusTrap(rootRef, { enabled: () => isTopRef.value })

provide(DIALOG_CONTEXT_KEY, {
  id:    props.entry.id,
  close: (result?: unknown) => closeDialog(props.entry.id, result),
})
</script>

<template>
  <div ref="rootRef" class="dialog-entry">
    <component :is="entry.component" v-bind="entry.props" />
  </div>
</template>

<style scoped>
/* Wrapper is layout-neutral so the child .dialog is what the grid backdrop
   places, not this wrapper. */
.dialog-entry {
  display: contents;
}
</style>
